import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'

import { env } from '@/env'

// Deployed builds send every error; traces are sampled in prd to protect the Sentry quota.
const TRACES_SAMPLE_RATE = { dev: 1, prd: 0.1 } as const

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  debug: import.meta.env.DEV,
  environment: import.meta.env.MODE,
  sampleRate: import.meta.env.DEV ? 0 : 1,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
      showBranding: false,
    }),
  ],

  tracesSampleRate: import.meta.env.DEV
    ? 0
    : TRACES_SAMPLE_RATE[env.VITE_FINTALK_ENV],
})
